import { BaseModel } from '../../common/base/model';

export class OwnerModel extends BaseModel {
  constructor(data) {
    super(data, {
      firstName: null,
      lastName: null,
      tin: null,
      birthday: null,
      address: null,
      zipCode: null,
      city: null
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/owner/owner.model.js